// client/src/features/diagnostics/DiagnosticsPanel.js

import React from 'react'

const DiagnosticsPanel = ({ issues = [], flaggedRows = [], onExport }) => (
  <div style={{ border: '2px solid #cc0000', padding: 20, marginBottom: 30, borderRadius: 10 }}>
    <h3 style={{ color: '#cc0000', marginTop: 0 }}>Diagnostics & Alerts</h3>
    <ul>
      {issues.slice(-10).map((issue, i) => (
        <li key={i}>
          <strong>{issue.reason}</strong> at {issue.time}
        </li>
      ))}
    </ul>
    <button onClick={onExport} style={{ marginBottom: 10 }}>Export Flagged Data (CSV)</button>
    <h4>Recent Suspect Data Points</h4>
    <div style={{ maxHeight: 200, overflowY: 'auto', fontSize: 13 }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ccc', padding: 5 }}>Time</th>
            <th style={{ border: '1px solid #ccc', padding: 5 }}>Reason(s)</th>
            <th style={{ border: '1px solid #ccc', padding: 5 }}>Raw Data</th>
          </tr>
        </thead>
        <tbody>
          {flaggedRows.slice(-10).map((row, i) => (
            <tr key={i}>
              <td style={{ border: '1px solid #ccc', padding: 5 }}>{row._time || row.sample_time}</td>
              <td style={{ border: '1px solid #ccc', padding: 5 }}>{row.reasons}</td>
              <td style={{ border: '1px solid #ccc', padding: 5 }}>
                {Object.entries(row)
                  .filter(([k]) => k !== 'reasons')
                  .map(([k, v]) => `${k}: ${v}`)
                  .join(', ')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)

export default DiagnosticsPanel
